import { render, staticRenderFns } from "./InspectionPage.vue?vue&type=template&id=4b5267d4&"
import script from "./InspectionPage.vue?vue&type=script&lang=js&"
export * from "./InspectionPage.vue?vue&type=script&lang=js&"
import style0 from "./InspectionPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports